import { jsx as _jsx } from "react/jsx-runtime";
import { Button as MuiButton, Skeleton, } from '@mui/material';
export const Button = (props) => {
    const { isLoading, skeletonSx, ...buttonProps } = props;
    const height = '2em';
    if (isLoading) {
        if (buttonProps.fullWidth) {
            return (_jsx(Skeleton, { variant: "rounded", height: height, sx: { marginTop: '1rem', ...skeletonSx } }));
        }
        else {
            return (_jsx(Skeleton, { variant: "rounded", width: "8em", height: height, sx: { marginTop: '1rem', ...skeletonSx } }));
        }
    }
    return _jsx(MuiButton, { ...buttonProps });
};
